import apiClient from 'apiClient';
import { Permissions, Adviser } from 'utils/user/types';

const REFRESH_TOKEN_ENDPOINT = '/api/v1/auth/jwt/refresh';
const USER_DATA_ENDPOINT = '/api/v1/auth/user/';
const LOGOUT_ENDPOINT = '/api/v1/auth/jwt/logout';
const LOGIN_ENDPOINT = '/api/v1/auth/jwt/obtain-token';

type LoginData = {
  access: string;
  name: string;
  role: string;
  permissions: Permissions;
  sessionid: string;
  feature_toggles: Map<string, boolean>;
  advisers: Adviser[];
};

type UserData = {
  id: number;
  role: string;
  name: string;
  permissions: Permissions;
  feature_toggles: Map<string, boolean>;
  email: string;
  advisers: Adviser[];
};

const getAccessToken = async (): Promise<string> => {
  const response = await apiClient.post(REFRESH_TOKEN_ENDPOINT, {}, { withCredentials: true });
  return response.data.access;
};

const getUserData = async (): Promise<UserData> => {
  const response = await apiClient.get(USER_DATA_ENDPOINT);
  return response.data;
};

const login = async (username: string, password: string): Promise<LoginData> => {
  const response = await apiClient.post(LOGIN_ENDPOINT, { username, password }, { withCredentials: true });
  return response.data;
};

const logout = async (): Promise<void> => {
  await apiClient.post(LOGOUT_ENDPOINT, {}, { withCredentials: true });
};

const exportObject = {
  getAccessToken,
  getUserData,
  login,
  logout,
};

export default exportObject;
